import React from 'react';

const SectionHeader = ({ label }) => (
    <div className="ct-section-header">
        <span>{label}</span>
    </div>
);

export default SectionHeader;
